"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteObjectOutput = {
    type: "structure",
    required: [],
    members: {
        DeleteMarker: {
            shape: {
                type: "boolean"
            },
            location: "header",
            locationName: "x-amz-delete-marker"
        },
        VersionId: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-version-id"
        },
        RequestCharged: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-request-charged"
        }
    }
};
//# sourceMappingURL=DeleteObjectOutput.js.map